import SearchArea from "./SearchArea"

export default SearchArea
